import React, { createContext } from 'react';

import { WsAlert } from '../core';

type WsPortalContextProps = {
  currentUser: any | undefined,
  // viewAs: any | undefined,
  // theme: any | undefined,
  // setTheme: React.Dispatch<any>,
  mySalesOfferings: any[] | undefined,
  allSalesOfferings: any[] | undefined,
  loadOffers: () => void,
  socketClient: SocketIOClient.Socket,
  showSuccess: ({ text }: any) => number | string,
  showError:   ({ text }: any) => number | string,
  setAlert: React.Dispatch<React.SetStateAction<WsAlert | undefined>>
};

const WsPortalContext = createContext<WsPortalContextProps | undefined>(undefined);

export {
  WsPortalContext
};
